<template>
    <div class="">
        <button
            ref="button"
            type="button"
            @click="isOpen = true"
            class="
                p-3
                text
                flex
                items-center
                rounded-lg
                hover:bg-gray-100
                gap-1
            "
        >
            <ion-icon name="chevron-down-outline"></ion-icon>
            <span>{{ searchColumns().length }} filters</span>
        </button>
        <input type="hidden" name="search_column" :value="searchColumns()" />
        <Teleport to="body">
            <div
                v-show="isOpen"
                class="
                    fixed
                    top-0
                    left-0
                    z-10
                    bg-white bg-opacity-10
                    w-full
                    h-full
                "
                @click.self="tryClose()"
            ></div>
            <div
                v-show="isOpen"
                ref="menu"
                class="
                    absolute
                    right-8
                    -top-8
                    bg-gray-200
                    shadow-lg
                    rounded-lg
                    p-4
                    z-20
                    w-auto
                    min-w-[200px]
                "
            >
                <ul class="space-y-2">
                    <li class="flex items-center gap-2">
                        <input
                            v-model="titleChecked"
                            type="checkbox"
                            name="search_column"
                            value="title"
                            id="search_column_title"
                        />
                        <label for="search_column_title">Thread Title</label>
                    </li>
                    <li class="flex items-center gap-2">
                        <input
                            v-model="bodyChecked"
                            type="checkbox"
                            name="search_column"
                            value="title"
                            id="search_column_body"
                        />
                        <label for="search_column_body">Thread Content</label>
                    </li>
                    <li class="flex items-center gap-2">
                        <input
                            v-model="authorChecked"
                            type="checkbox"
                            name="search_column"
                            value="title"
                            id="search_column_author"
                        />
                        <label for="search_column_author">Author</label>
                    </li>
                    <li class="flex items-center gap-2">
                        <input
                            v-model="repliesChecked"
                            type="checkbox"
                            name="search_column"
                            value="title"
                            id="search_column_replies"
                        />
                        <label for="search_column_replies">Replies</label>
                    </li>
                </ul>
                <div
                    class="mt-4 p-2 text-xs bg-red-300 rounded-md text-red-950"
                    v-if="searchColumns().length === 0"
                >
                    Please select at least one filter
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
    name: "ContextMenu",
    data() {
        return {
            isOpen: false,
            titleChecked: false,
            bodyChecked: false,
            authorChecked: false,
            repliesChecked: false,
        };
    },
    props: {
        defaultColumns: {
            type: String,
            default: () => "title,author",
        },
    },
    mounted() {
        const columns = this.defaultColumns.split(",");
        this.titleChecked = columns.includes("title");
        this.bodyChecked = columns.includes("body");
        this.authorChecked = columns.includes("author");
        this.repliesChecked = columns.includes("replies");
    },
    methods: {
        searchColumns() {
            let columns = [];
            if (this.titleChecked) {
                columns.push("title");
            }
            if (this.bodyChecked) {
                columns.push("body");
            }
            if (this.authorChecked) {
                columns.push("author");
            }
            if (this.repliesChecked) {
                columns.push("replies");
            }
            return columns;
        },
        tryClose() {
            if (this.searchColumns().length > 0) {
                this.isOpen = false;
            }
        },
    },
    updated() {
        if (this.isOpen) {
            this.$nextTick(() => {
                createPopper(this.$refs.button, this.$refs.menu, {
                    placement: "bottom-start",
                    boundariesElement: "viewport",
                }).forceUpdate();
            });
        }
    },
};
</script>

<style scoped></style>
